export const snapshotsRoutes = {
  default: 'account-snapshots-v2',
  import: 'import_account_template_v2',
  type: 'snapshots-v2',
  edit: 'edit-snapshot',
  history: 'history'
}
